import {
	Component,
	HostBinding,
	Input,
	OnInit
}                        from '@angular/core';
import {
	AbstractControl,
	FormControlStatus,
	ValidationErrors
}                        from '@angular/forms';
import { BaseComponent } from '@app/core/bases/base-component/base.component';
import {
	formErrorFadeInOut,
	formErrorSlideUpDown
}                        from '@app/shared/animations/slideUpDown';
import { Subscription }  from 'rxjs';
import { takeUntil }     from 'rxjs/operators';

@Component( {
	selector: 'app-error[control][hideErrors]',
	templateUrl: './error.component.html',
	styleUrls: [ './error.component.scss' ],
	animations: [ formErrorSlideUpDown, formErrorFadeInOut ]
} )
export class ErrorComponent extends BaseComponent implements OnInit {

	private _abstractControl: AbstractControl;
	private _controlStatusSubscription: Subscription;
	private readonly defaultCssClassList: string = 'd-block';
	private _errorMsg: string[];
	public errors: ValidationErrors;
	public hasErrors: boolean;
	private _hideErrors = true;


	// ENFORCED INPUTS
	@Input() set control( control: AbstractControl ) {
		this._abstractControl = control;
		this.subscribeToControlStatus();
	}

	@Input() set hideErrors( hideErrors: boolean ) {
		this._hideErrors = hideErrors;
		this.computeErrorCount();
	}

	get hideErrors(): boolean {
		return this._hideErrors;
	}


	// OPTIONAL INPUTS
	@Input() cssClassList: string;

	@Input() set errorMsg( errorMsg: string[] ) {
		this._errorMsg = errorMsg;
		this.computeErrorCount();
	}

	get errorMsg(): string[] {
		return this._errorMsg;
	}

	@HostBinding( 'class' ) baseCssClassList;

	constructor() {
		super();
	}

	private computeErrorCount(): void {
		if ( !this._abstractControl ) { return; }

		this.errors = this._abstractControl?.errors;

		this.hasErrors = this._errorMsg?.length > 0 ||
										 !!this._abstractControl?.errors;

		this.logger.debug( 'hasErrors', this.hasErrors, 'errors', this.errors );
	}

	private subscribeToControlStatus(): void {
		if ( !this._abstractControl ) { return; }

		if ( this._controlStatusSubscription ) {
			this._controlStatusSubscription.unsubscribe();
		}

		this._controlStatusSubscription = this._abstractControl?.statusChanges
		.pipe(
			takeUntil( this.ngUnsubscribe )
		)
		.subscribe( ( status: FormControlStatus ) => {
			this.logger.debug( 'status', status );
			this.computeErrorCount();
		} );
	}

	ngOnInit(): void {
		this.baseCssClassList = this.defaultCssClassList;

		if ( this.cssClassList ) {
			this.baseCssClassList = this.defaultCssClassList + ' ' + this.cssClassList;
		}
	}
}
